'use client'

import React, { useEffect, useState } from 'react'
import styles from './SaleCountdown.module.css'
import { splitRemaining } from '../../lib/saleCampaign'

const pad = (n) => (n < 10 ? `0${n}` : `${n}`)

// `live`: the caller's clock ticks slowly (e.g. the shop grid, once a minute)
// and this countdown keeps its own 1 s clock, carrying the caller's preview
// offset (nowMs - Date.now()). Only the digits re-render each second.
function useLiveNow(nowMs, mounted, live) {
  const [liveNow, setLiveNow] = useState(nowMs)
  useEffect(() => {
    if (!live || !mounted) return undefined
    const offset = nowMs - Date.now()
    setLiveNow(Date.now() + offset)
    const id = setInterval(() => setLiveNow(Date.now() + offset), 1000)
    return () => clearInterval(id)
  }, [live, mounted, nowMs])
  return live && mounted ? liveNow : nowMs
}

// Days / Hrs / Mins / Secs boxes counting down to `targetMs`.
// Replaces ItemCountdownBF2025 for 2026: the interval is owned by the caller's
// useSaleClock (cleared on unmount), and an expired timer renders nothing
// instead of negative numbers. `mounted=false` (SSR + hydration render) shows
// placeholders so the server HTML never bakes in a stale second count.
function SaleCountdown({ targetMs, nowMs, mounted = true, size = 'md', theme = 'dark', label = null, showDays = true, live = false }) {
  const tickNow = useLiveNow(nowMs, mounted, live)
  const r = splitRemaining(targetMs, tickNow)
  if (mounted && r.total <= 0) return null
  const units = [
    showDays || r.days > 0 ? ['Days', r.days] : null,
    ['Hrs', r.hours],
    ['Mins', r.minutes],
    ['Secs', r.seconds],
  ].filter(Boolean)
  return (
    <div className={[styles.wrap, styles[size], styles[theme]].filter(Boolean).join(' ')} role="timer" aria-live="off">
      {label && <span className={styles.label}>{label}</span>}
      <div className={styles.units}>
        {units.map(([name, value], i) => (
          <React.Fragment key={name}>
            {i > 0 && <span className={styles.sep}>:</span>}
            <span className={styles.unit}>
              <span className={styles.value}>{mounted ? pad(value) : '--'}</span>
              <span className={styles.name}>{name}</span>
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default SaleCountdown
